import { ProductType } from '../../../shared/types/domain';
import { usesAmsAuthoritativeResidenceVerification } from '../../../config';

export type ResidenceVerificationFlow = 'ams-authoritative' | 'legacy';

export interface ResidenceVerificationFlowResolution {
  isReady: boolean;
  flow?: ResidenceVerificationFlow;
  reason?: string;
}

export function resolveResidenceVerificationFlow(
  productType: ProductType | string | null | undefined,
): ResidenceVerificationFlow {
  return usesAmsAuthoritativeResidenceVerification(productType)
    ? 'ams-authoritative'
    : 'legacy';
}

export function resolveActiveResidenceVerificationFlow(
  applicationData: { productType?: ProductType | string | null } | null | undefined,
  isApplicationLoading: boolean,
): ResidenceVerificationFlowResolution {
  if (isApplicationLoading) {
    return {
      isReady: false,
      reason: 'Application details are still loading. Please wait before submitting.',
    };
  }

  if (!applicationData) {
    return {
      isReady: false,
      reason:
        'Application details could not be loaded, so residence verification cannot be submitted safely.',
    };
  }

  return {
    isReady: true,
    flow: resolveResidenceVerificationFlow(applicationData.productType),
  };
}

export function parseThirdPartyReference(
  value: string | boolean | null | undefined,
): boolean | undefined {
  if (typeof value === 'boolean') return value;
  if (value === 'Positive') return true;
  if (value === 'Negative') return false;
  return undefined;
}
